import { render, staticRenderFns } from "./resiliation.vue?vue&type=template&id=6030a9ea&"
import script from "./resiliation.vue?vue&type=script&lang=js&"
export * from "./resiliation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports